import store from '@/store';
import BADGES_COLOR_MAP from '@/data/badges-color-map';

export default function createColumns(expandData, resendWebhook) {
    return {
        store,
        version: 3,
        defaultColumns: [
            {
                name: 'sentTime',
                type: 'datetime',
                sortable: true,
                sticky: true,
            },
            {
                name: 'id',
                style: {truncate: true},
            },
            {
                name: 'eventType',
            },
            {
                name: 'url',
            },
            {
                name: 'method',
                type: 'badge',
                map: BADGES_COLOR_MAP.method,
            },
            {
                name: 'responseCode',
            },
            {
                name: 'attempt',
                type: 'numeric',
            },

        ],
        otherColumns: [
            {
                name: 'headers',
            },
            {
                name: 'payload',
            },
            {
                name: 'responseBody',
            },
            {
                name: 'source',
            },
            {
                name: 'createdTime',
                header: 'Creation Time',
                type: 'datetime',
                sortable: true,
            },
            {
                name: 'initiatedTime',
                type: 'datetime',
            },
        ],
        lockedColumns: [
            {
                header: false,
                type: 'nested',
                style: {textRight: true},
                columns: [
                    {
                        type: 'button',
                        style: {
                            tooltip: 'Resend',
                            icon: 'reset',
                        },
                        click: ({rowData, grid}) => resendWebhook(rowData, grid),
                    },
                    {
                        type: 'button',
                        style: {
                            tooltip: 'Expand Data',
                            icon: 'eye',
                        },
                        click: ({rowData, grid}) => expandData(rowData, grid),
                    },
                ],
            },
        ],
    };
}
